import intl from 'components/i18n/ReactIntlWrapper';

export function handleAPIError(error: any, toast: any, errors: any) {
    switch (error.response?.status) {
        case 400: {
            const responseErrors = error.response.data?.errors;
            if (responseErrors) {
                errors.summary = [];
                if (Array.isArray(responseErrors)) {
                    // Our custom error format: [{errorLabelKey, errorMessage}, ...]
                    responseErrors.forEach(element => {
                        const msg = intl.get(element.errorLabelKey) || element.errorMessage;
                        errors.summary = [...errors.summary, msg];
                    });
                } else if (typeof responseErrors === 'object') {
                    // ASP.NET ModelState format: { "field": ["message1", ...], ... }
                    Object.values(responseErrors).forEach((messages: string[]) => {
                        messages.forEach(msg => {
                            errors.summary = [...errors.summary, msg];
                        });
                    });
                }
                toast.error({ header: intl.get('error'), body: error.response.data?.title || 'One or more validation errors occurred.' });
            } else {
                const msg = error.response.data?.title || error.response.data?.message || error?.message;
                errors.summary = [msg];
                toast.error({ header: intl.get('error'), body: msg });
            }
            break;
        }
        case 404:
            error.response.data.errors.forEach(element => {
                toast.error({ header: intl.get('error'), body: intl.get(element.errorLabelKey) });
            });
            break;
        case 406: //Fill the collection for showing the validation errors above the form
            errors.summary = [];
            error.response.data.errors.forEach(element => {
                errors.summary = [...errors.summary, intl.get(element.errorLabelKey)];
            });
            break;
        case 401:
            toast.error({ header: intl.get('error'), body: error?.message });
            break;
        case 500:
            toast.error({ header: intl.get('error'), body: error?.message });
            break;
    }
}